/*global initPopupCloseFunction, initPlannedCompletionDateChangeListener, handleStatusChange*/
/*eslint @typescript-eslint/no-explicit-any:0 */
/* TODO: replace any (object might work but currently not recommended due to typescript issue) */
import { initPlannedCompletionDateChangeListener, handleStatusChange } from './finish-case-dialog';
import { initPopupCloseFunction } from './popup';
jQuery(function () {
    if ($('.calendar').length < 1) {
        return;
    }
    var calendarMenu = $('.js-calendar-item-menu');
    var passedCalendarItemToggle = $('.js-toggle-passed-calendar-items-btn');
    var calendarItemRemoveBtn = $('.js-calendar-item-remove-btn');
    var calendarItemEditBtn = $('.js-calendar-item-edit-btn');
    var removePopup = $('#calendar-remove-popup');
    calendarMenu.on('click', function () {
        var btn = $(this);
        var menu = btn.closest('.calendar-item').find('.calendar-item__back');
        if (btn.hasClass('is-active')) {
            btn.removeClass('is-active');
            menu.animate({
                height: 'toggle',
                opacity: 'toggle'
            });
        }
        else {
            btn.addClass('is-active');
            menu.animate({
                height: 'toggle'
            });
        }
    });
    passedCalendarItemToggle.on('click', function () {
        $(this).toggleClass('expanded');
        $('.calendar__toggle-list').slideToggle();
    });
    calendarItemRemoveBtn.on('click', function () {
        var calendarItem = $(this).closest('.calendar-item');
        var itemId = calendarItem.attr('data-id');
        var itemType = calendarItem.attr('data-type');
        var itemTypeString = calendarItem.attr('data-type-string');
        removePopup.find('input[name="id"]').val(itemId);
        removePopup.find('input[name="calendarItemType"]').val(itemType);
        removePopup.find('.js-calendar-item-remove-type').text(itemTypeString);
        removePopup.parent().addClass('visible');
    });
    calendarItemEditBtn.on('click', function () {
        var calendarItem = $(this).closest('.calendar-item');
        var id = calendarItem.attr('data-id');
        var calendarItemType = calendarItem.attr('data-type');
        $.ajax({
            url: 'kalender/redigera',
            data: { id: id, calendarItemType: calendarItemType }
        }).done(function (response) {
            $('#calendar-edit-popup').parent().replaceWith(response);
            initPopupCloseFunction();
            initCompletionDropdowns();
            initPlannedCompletionDateChangeListener();
            $('#calendar-edit-popup').parent().addClass('visible');
        });
    });
    function initCompletionDropdowns() {
        var $years = $('.js-planned-completion-date').find('[data-role=\'year\']');
        var $months = $('.js-planned-completion-date').find('[data-role=\'month\']');
        var isCompleted = false;
        handleStatusChange(isCompleted, $years, $months);
    }
});
